import React from 'react'
import TechnologyCard from './TechnologyCard'


const AllTechnologies = ({title, desc, cards}) => {
  return (
      <div className='flex flex-col gap-[40px]'>
          <div className='flex flex-col gap-[16px] font-faustina text-white text-center'>
              <p className=' font-semibold lg:text-[56px] md:text-[40px] xs:text-[clamp(28px,5.2vw,40px)] text-head-gradient '>{title}</p>
              <p className='font-regular lg:text-[20px] xs:text-[clamp(16px,2.7vw,20px)] text-white'>{desc}</p>
          </div>

          {/* ------------------------------------------ Card Component --------------------------------------------------- */}
        
          <div className="flex flex-wrap justify-center gap-[20px] w-full">
              {cards?.map((card, i) => (
                  <div key={i} className="flex-grow-0">
                      <TechnologyCard img={card.image} heading={card.title} />
                  </div>
              ))}
          </div>


          {/* ------------------------------------------ Card Component --------------------------------------------------- */}

    </div>
  )
}

export default AllTechnologies